import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'

import { imageLoader } from '../../../loaders/imageLoader/imageLoader'
import { legacyImageLoader } from '../../../loaders/imageLoader/legacyImageLoader'
import type { DamFeatureFlagVariables } from '../../../types/types'

export const useImageLoader = () => {
	const { variables } = useFeatureFlag<DamFeatureFlagVariables>(
		featureFlagKeys.Dam
	)

	return variables.isImageEnabled ? imageLoader : legacyImageLoader
}
